var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"w-100 h-100",staticStyle:{"position":"relative"}},[_c('textarea',{attrs:{"id":_vm.id}}),(!_vm.hideWatermark)?_c('div',{staticClass:"text-editor-watermark"},[_c('img',{attrs:{"src":require("@/assets/img/VU-LOGO.png"),"alt":"Logo"}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }